import { ISubscription, ISubscriptions } from "@/interfaces/bundle.interface";
import { atom, RecoilState } from "recoil";

export const subscriptionsState: RecoilState<ISubscriptions> = atom({
  key: "subscriptions",
  default: { count: 0, results: [] },
});

export const subscriptionState: RecoilState<Partial<ISubscription>> = atom({
  key: "subscription",
  default: {},
});
